import { Container } from '@tencent/alloy-renderer';
import { IWrapperComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/types';
import { InterfaceFactoryOptions } from './factory-options.interface';
import { buildTreeSync } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/slide/build-tree-sync';
import { CANVAS_GROUP_ID_PREFIX } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { GroupRefreshMenu } from '@src/slide/domain/ui-model/element-modeles/property/menu-property/refresh/group';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';

/**
 * 组合模块
 * 直接遍历children，调用factory递归渲染图形
 * 此处MouseDown、MouseUp区别于其他图形，但是应该可以优化统一
 */
export class RendererGroupComponent extends Container {
    private readonly factoryOptions: InterfaceFactoryOptions<IGroupModel>;
    private needMouseUp;
    private hasDidMount = false;

    public constructor(factoryOptions: InterfaceFactoryOptions<IGroupModel>) {
        super();
        this.factoryOptions = factoryOptions;
        if (!this.factoryOptions.asyncBuild) {
            this.updateComponent();
        }
        const { model } = this.factoryOptions;
        this.id = `${CANVAS_GROUP_ID_PREFIX}-${model.key}`;
    }

    /**
     * 构造子元素需要的factoryOption
     * @param childModel
     */
    public childFactoryOption<M = any>(childModel: M): InterfaceFactoryOptions<M> {
        return {
            ...this.factoryOptions,
            model: childModel,
            isGroupChildren: true,
        };
    }

    public updateComponent = () => {
        // 缩放旋转的过程中，不绘制子元素
        const { editingStateManager } = this.factoryOptions;
        if (editingStateManager?.isRotating || editingStateManager?.isResizing) return;

        buildTreeSync({
            canvasLayer: this,
            canvasArr: this.children as IWrapperComponent[],
            modelsArr: this.factoryOptions.model.children,
            componentFactoryOptions: this.childFactoryOption(null),
            componentNeedUpdate: true,
        });

        if (!this.hasDidMount) {
            this.componentDidMount();
            this.hasDidMount = true;
        }
    };

    private componentDidMount() {
        const { model } = this.factoryOptions;
        // 更新group的itemValues
        GroupRefreshMenu.caculateItemValues(model);
    }
}
